// ZOHAAN Fresh Theme - Core JS
document.addEventListener('DOMContentLoaded', function() {
  // Wishlist (delegated — also covers buttons added later via JS)
  const wishlist = JSON.parse(localStorage.getItem('zohaan_wishlist') || '[]');
  updateWishBadges();

  function wishKey(x){ return String((typeof x === 'object' && x) ? (x.h || x.handle || x.u || '') : x); }
  document.querySelectorAll('.wish-btn').forEach(btn => {
    if (wishlist.map(wishKey).indexOf(String(btn.dataset.productId)) > -1) btn.classList.add('active');
  });
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.wish-btn');
    if (!btn || btn.closest('.wish-page')) return; // wishlist page manages its own hearts
    e.preventDefault();
    const id = String(btn.dataset.productId);
    const idx = wishlist.map(wishKey).indexOf(id);
    if (idx > -1) { wishlist.splice(idx, 1); btn.classList.remove('active'); }
    else { wishlist.push(id); btn.classList.add('active'); }
    localStorage.setItem('zohaan_wishlist', JSON.stringify(wishlist));
    updateWishBadges();
  });
  
  function updateWishBadges() {
    document.querySelectorAll('.wish-count').forEach(el => {
      el.textContent = wishlist.length;
      el.style.display = wishlist.length ? 'flex' : 'none';
    });
  }
  
  // Cart count
  fetch('/cart.js').then(r => r.json()).then(cart => {
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count ? 'flex' : 'none';
    });
  });
  
  // Quick add
  document.querySelectorAll('.quick-add').forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const id = btn.dataset.variantId;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: id, quantity: 1})
      }).then(r => r.json()).then(() => {
        location.reload();
      });
    });
  });
  
  // Quantity
  document.querySelectorAll('.qty').forEach(qty => {
    const input = qty.querySelector('input');
    qty.querySelector('.qty-minus').addEventListener('click', () => {
      input.value = Math.max(1, parseInt(input.value) - 1);
    });
    qty.querySelector('.qty-plus').addEventListener('click', () => {
      input.value = parseInt(input.value) + 1;
    });
  });
  
  // Mobile menu
  const menuBtn = document.querySelector('.mobile-menu-btn');
  const mobileNav = document.querySelector('.mobile-nav');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', () => mobileNav.classList.toggle('open'));
  }
});
